
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bedroom-design-app",
      function () {
        return require("private-next-pages/bedroom-design-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bedroom-design-app"])
      });
    }
  